module.exports = __webpack_public_path__ + "static/nm-script.5da446cb.woff2";